import { gql } from "@apollo/client";

export const GET_PREFERENCES = gql`
  query getPreferences {
    preferences {
      customer_preferences {
        has_findings
        severity_as_priority
        ticket_due_date_enabled
        severity_as_priority_mapping
        identity_provider
        password_enabled
        using_new_trends
        use_clickhouse
        use_ai
        account_type
        use_plain_unified_resources
        use_resource_attributes
        open_seemplicity_findings
      }
      user_preferences {
        user_id
        any_scopes
        role
        user_actions {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const SET_USE_AI = gql`
  mutation set_use_ai($use_ai: Boolean!) {
    set_use_ai(use_ai: $use_ai) {
      ok
    }
  }
`;
